<template>
  <DialogLayout class="teaching-supply-elective-apply">
    <template #header>
      <div class="header">
        <span class="title custom-title">
          <span>{{rowData.trueName}} / {{rowData.regNo}}</span>
          <span>班级：{{rowData.className}}</span>
          <span>教学点：{{rowData.siteName}}</span>
        </span>
      </div>
    </template>
    <template>
      <TeachingSupplyElectiveApplyMain :elective-id="rowData.id"
                                       v-bind="$attrs"
                                       v-on="$listeners"></TeachingSupplyElectiveApplyMain>
    </template>
  </DialogLayout>
</template>

<script>
import DialogLayout from '../../../../../../../widgets/DialogLayout'
import TeachingSupplyElectiveApplyMain from './main'
export default {
  name: 'TeachingSupplyElectiveApply',
  components: {
    DialogLayout,
    TeachingSupplyElectiveApplyMain
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
  .teaching-supply-elective-apply {
    max-width: 100%;
    width: 960px;
    height: 100%;
    .custom-title {
      & > span {
        font-size: 12px;
        font-weight: bold;
        & + span {
          margin-left: 15px;
        }
      }
    }
  }
</style>
